import {
  ReactElement, ReactNode, SyntheticEvent, useState,
} from 'react';
import { ButtonBase } from '@mui/material';
import { RebalanceTab } from './rebalancePage/sharedTypes';
import { useThemeTokens } from '../../../providers/themeTokenProvider';
import { useTabNavTokens } from '../../3-pattern/tabNav/tabNav.tokens';
import { Grid } from '../../1-primative';

type RebalanceTabsProps = {

  tabs: RebalanceTab[];
  onChange: (event: SyntheticEvent, tab: RebalanceTab) => void;
  children: ReactNode;

};

const RebalanceTabs = ({
  tabs,
  children,
  onChange,
}: RebalanceTabsProps): ReactElement => {
  const [currentTab, setCurrentTab] = useState<RebalanceTab>(tabs[0]);
  const tokens = useThemeTokens(useTabNavTokens());
  const { comp } = tokens;

  const handleTabChange = (event: SyntheticEvent, value: RebalanceTab) => {
    setCurrentTab(value);
    onChange(event, value);
  };

  return (
    <>
      <Grid container gap={0.1} flexWrap={'nowrap'} mb={3}>
        {tabs.map((item) => (
          <Grid item>
            <ButtonBase
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                color: item.accessor === currentTab.accessor ? comp.tabNav.text.active : comp.tabNav.text.default,
                borderRadius: comp.tabNav.borderRadius,
                backgroundColor: item.accessor === currentTab.accessor ? comp.tabNav.background.active : comp.tabNav.background.default,
                height: comp.tabNav.height,
                width: comp.tabNav.width,
                whiteSpace: comp.tabNav.width === 'auto' ? 'nowrap' : 'normal',
                padding: comp.tabNav.padding,
                mr: 1.5,
                '&:hover': {
                  color: comp.tabNav.text.hover,
                  cursor: 'pointer',
                },
                '&:focus': {
                  backgroundColor: comp.tabNav.background.hover,
                  color: comp.tabNav.text.hover,
                  cursor: 'pointer',
                },
              }}
              key={item.accessor}
              onClick={(event) => handleTabChange(event, item)}>
              {item.name}
            </ButtonBase>
          </Grid>
        ))}
      </Grid>
      {children}
    </>
  );
};

export default RebalanceTabs;
